import * as React from 'react';
import { useHistory } from 'react-router-dom';

const customUrl = (podname: string) => {
  let newUrl = `https://console.aws.amazon.com/cloudformation/home?#/stacks/new?stackName=ArcticWolf&templateURL=https://s3.amazonaws.com/arcticwolf-public/install/aws-templates/${podname}/latest/primary_region_template.json`;
  return newUrl;
};

const CustomerPodUrl = () => {
  const history = useHistory();
  React.useEffect(() => {
    fetch('api/v2/userinfo/pod')
      .then((response) => response.json())
      .then((data) => {
        let podName = data.properties.pod;
        history.push(customUrl(podName));
      });
  }, [history]);
  return (
    <div>
      <div data-cy="loading">Loading...</div>
    </div>
  );
};

export default CustomerPodUrl;
